module.exports = __webpack_public_path__ + "images/db5538532f13b24eafd9ea84eb4919c0-Madeira.png";